import React, { useState, useEffect } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [activeItem, setActiveItem] = useState('HOME');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { id: '01', name: 'HOME', path: '/' },
    { id: '02', name: 'ABOUT US', path: '/about' },
    { id: '03', name: 'SERVICES', path: '/services' },
    { id: '04', name: 'OUR TEAM', path: '/team' },
    { id: '05', name: 'CLIENTS', path: '/industries' },
  ];

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.mobile-sidebar') && !event.target.closest('.mobile-menu-btn')) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const handleMenuItemClick = (itemName, itemPath) => {
    setActiveItem(itemName);
    setIsMobileMenuOpen(false);
    
    // Navigate to the path
    window.location.href = itemPath;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          {/* Logo */}
          <div className="navbar-logo">
            <img src="/assets/images/logo.png" alt="Pecunia Innovations" className="logo-image" />
          </div>

          {/* Desktop Navigation Menu */}
          <ul className="navbar-menu desktop-menu">
            {menuItems.map((item) => (
              <li key={item.id} className="navbar-item">
                <a 
                  href={item.path}
                  className={`navbar-link ${activeItem === item.name ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleMenuItemClick(item.name, item.path);
                  }}
                >
                  <span className="menu-number">{item.id}</span>
                  <span className="menu-text">{item.name}</span>
                </a>
              </li>
            ))}
          </ul>

          {/* Right Side */}
          <div className="navbar-right">
            {/* Contact Us Button - Hidden on mobile */}
            <button className="consult-btn contact-btn" onClick={() => window.location.href = '/contactus'}>
              Contact Us
            </button>
            
            {/* Get Consult Button */}
            <button className="consult-btn" onClick={() => window.location.href = '/form'}>
              Get Consult
            </button>

            {/* Mobile Menu Button */}
            <button 
              className="mobile-menu-btn"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar Overlay */}
      <div className={`mobile-overlay ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className={`mobile-sidebar ${isMobileMenuOpen ? 'active' : ''}`}>
          {/* Close Button */}
          <button 
            className="close-btn"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>

          {/* Mobile Menu Items */}
          <ul className="mobile-menu">
            {menuItems.map((item) => (
              <li key={item.id} className="mobile-menu-item">
                <a 
                  href={item.path}
                  className={`mobile-menu-link ${activeItem === item.name ? 'active' : ''}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleMenuItemClick(item.name, item.path);
                  }}
                >
                  <span className="mobile-menu-text">{item.name}</span>
                  <svg className="mobile-menu-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navbar;